export default __webpack_public_path__ + "static/media/ig-post-2.58e45134.jpeg";